import React, { useState } from "react";
import { Modal, Button, TextField, Box, Typography } from "@mui/material";

interface OnboardingAddModalProps {
  open: boolean;
  onClose: () => void;
  onAdd: (title: string, imageFile: File) => void;
  type: "first" | "second";
}

export const OnboardingAddModal: React.FC<OnboardingAddModalProps> = ({
  open,
  onClose,
  onAdd,
  type,
}) => {
  const [title, setTitle] = useState("");
  const [imageFile, setImageFile] = useState<File | null>(null);

  const handleSubmit = () => {
    if (!title || !imageFile) {
      alert("Please fill all fields");
      return;
    }
    onAdd(title, imageFile);
    setTitle("");
    setImageFile(null);
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          minWidth: 400,
        }}
      >
        <Typography variant="h6" gutterBottom>
          Add New {type === "first" ? "Platform" : "Content"}
        </Typography>

        <TextField
          fullWidth
          label="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          margin="normal"
        />

        <Box sx={{ my: 2 }}>
          <input
            accept="image/*"
            type="file"
            onChange={(e) => setImageFile(e.target.files?.[0] || null)}
            style={{ display: "none" }}
            id="image-upload"
          />
          <label htmlFor="image-upload">
            <Button variant="contained" component="span">
              Upload Image
            </Button>
          </label>
          {imageFile && (
            <Typography sx={{ mt: 1 }}>Selected: {imageFile.name}</Typography>
          )}
        </Box>

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="contained" onClick={handleSubmit}>
            Add
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
